import Attachment from 'lib/project/classes/Attachment';
import BillTicket from './BillTicket';

class TicketForm {
  constructor() {
    this.isMulti = true;
    this.description = null;
    this.attachment = new Attachment;
    this.billTariffs = [new BillTicket];
    this.currency = null;
    this.type = 'TICKET';
  }

  addTariff() {
    this.billTariffs.push(new BillTicket);
  }

  deleteTariff(idx) {
    this.billTariffs.splice(idx, 1);
  }

  tariffUp(idx) {
    const { billTariffs } = this;

    const billTariffsCopy = billTariffs.slice();
    const currTariff = billTariffsCopy[idx];
    const prevTariff = billTariffsCopy[idx - 1];

    billTariffs.splice(idx - 1, 2, currTariff, prevTariff);
  }

  tariffDown(idx) {
    const { billTariffs } = this;

    const billTariffsCopy = billTariffs.slice();
    const currTariff = billTariffsCopy[idx];
    const nextTariff = billTariffsCopy[idx + 1];

    billTariffs.splice(idx, 2, nextTariff, currTariff);
  }

  getData() {
    return {
      type: this.type,
      multiBill: this.isMulti,
      description: this.description || null,
      attachment: this.attachment.getData(),
      billTariffs: this.billTariffs.map(tariff => {
        return {
          id: tariff.id,
          name: tariff.name,
          description: tariff.description || null,
          amount: tariff.getAmount(this.currency),
          currency: this.currency,
          arrangement: this.isMulti
            ? tariff.arrangement.getData()
            : tariff.arrangement.getDataBySingleBill(),
        };
      }),
    };
  }
}

export default TicketForm;
